export const envVars = {
  DASHBOARD_API_BASE_URL:
    "https://clouseau-be-d4fhdjcrathkbrcz.swedencentral-01.azurewebsites.net/v1/dashboard",
  // DASHBOARD_API_BASE_URL: "http://localhost:3001/v1/dashboard",
};
